var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconImportHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button/import/hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.62285714,3.42857143 L5.71428571,3.42857143 L5.71428571,0.571428571 C5.71428571,0.257142857 5.45714286,0 5.14285714,0 L2.85714286,0 C2.54285714,0 2.28571429,0.257142857 2.28571429,0.571428571 L2.28571429,3.42857143 L1.37714286,3.42857143 C0.868571429,3.42857143 0.611428571,4.04571429 0.971428571,4.40571429 L3.59428571,7.02857143 C3.81714286,7.25142857 4.17714286,7.25142857 4.4,7.02857143 L7.02285714,4.40571429 C7.38285714,4.04571429 7.13142857,3.42857143 6.62285714,3.42857143 Z M0,9.14285714 C0,9.45714286 0.257142857,9.71428571 0.571428571,9.71428571 L7.42857143,9.71428571 C7.74285714,9.71428571 8,9.45714286 8,9.14285714 C8,8.82857143 7.74285714,8.57142857 7.42857143,8.57142857 L0.571428571,8.57142857 C0.257142857,8.57142857 0,8.82857143 0,9.14285714 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button/import/hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C8DDE7",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/import",
    transform: "translate(4.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neutral-Fill",
    mask: "url(#mask-2)",
    fill: "#5697B7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -3.000000)",
    id: "Fill"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImportHover);
export default __webpack_public_path__ + "static/media/icon_import_hover.2becc364dcbc32b4cefa4e1f3b56e2fc.svg";
export { ForwardRef as ReactComponent };